export default __webpack_public_path__ + "static/media/BoltsImg.7576beef.jpg";